import { SelectedContact } from '@mm/state/interfaces/contacts';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';
import { LinkedContacts } from '../../../liveChat/components/Contact/components/LinkedContacts';
import Notes from '../../../liveChat/components/Contact/components/Notes';
import { OTNTags } from '../../../liveChat/components/Contact/components/OTNTags';
import Sessions from '../../../liveChat/components/Contact/components/Sessions';
import { ContactDeleteModal } from '../ContactDeleteModal/ContactDeleteModal';
import './contactDetails.scss';
import ContactsDetailsHeader from './contactDetailsHeader/contactDetailsHeader';
import ChatVariablesTab from './contactDetailsTabs/chatVariablesTab/chatVariablesTab';
import { ChatVariablesTags } from './contactDetailsTabs/chatVariablesTags/chatVariablesTags';

type OuterProps = {
  selectedContact: SelectedContact;
  closeDetails: () => void;
  onDeleteSelectedContact: (
    id: number,
    deleteRemoteMessages: boolean,
  ) => Promise<void>;
  onContactSelect?: (id: number) => void;
  refreshSelectedContact: () => void;
};

const ContactsDetails = (props: OuterProps) => {
  const {
    selectedContact,
    closeDetails,
    onDeleteSelectedContact,
    refreshSelectedContact,
    onContactSelect = () => {},
  } = props;

  const displayVariables = selectedContact.variables?.filter(
    v => v.variable.name !== 'fb messenger user id',
  );

  const otnTags = selectedContact.tags.filter(tag => tag.kind === 'otn');

  const onContactClick = (contact: SelectedContact) =>
    onContactSelect(contact.id);

  const chatbotId = useSelector(activeChatbotIdSelector);
  const router = useRouter();

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <div className="contact-details">
      <ContactsDetailsHeader
        deleteSelectedContact={() => setShowDeleteModal(true)}
        closeDetails={closeDetails}
        selectedContact={selectedContact}
        onChangeContactInfo={refreshSelectedContact}
      />
      <div className="contact-details__blocks">
        <LinkedContacts
          linkedContacts={selectedContact.linkedContacts}
          onContactClick={onContactClick}
        />
        <ChatVariablesTags
          contactId={selectedContact.id}
          tags={selectedContact.tags}
          onChange={refreshSelectedContact}
        />
        <Sessions
          contact={selectedContact}
          onSessionClick={(session, contact, setSessionIdCallback) => {
            router.history.push(
              BotBuilderRoutes.liveChat.getLink({
                chatbotId,
                remoteUserId: contact.remoteId,
              }),
            );
            setSessionIdCallback(closeDetails);
          }}
        />
        <Notes
          contactId={selectedContact.id}
          notes={selectedContact.notes}
          onChange={refreshSelectedContact}
        />
        <OTNTags contactId={selectedContact.id} otnTags={otnTags} />
        <ChatVariablesTab
          contactId={selectedContact.id}
          variables={displayVariables}
          onAttributeUpdated={refreshSelectedContact}
          remoteUserId={selectedContact.remoteId}
        />
      </div>
      <ContactDeleteModal
        showEraseRemoteMessagesOption={selectedContact.remoteId.startsWith(
          'em_',
        )}
        show={showDeleteModal}
        emailAddress={selectedContact.email}
        onClose={() => setShowDeleteModal(false)}
        onDelete={eraseRemoteMessages =>
          onDeleteSelectedContact(selectedContact.id, eraseRemoteMessages)
        }
      />
      x{' '}
    </div>
  );
};

export default ContactsDetails;
